import store from './index'
import './user'
import './equipment'
import './refund'

export default store